import qs from "qs";
import authAxios, { authHeader } from "../data";

const fetchAll = async (req: {
  pageSize: number;
  pageNumber: number;
  contractId: string;
  year: number;
}) => {
  const result = await authAxios.get("/api/PaymentHistories", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const fetchCount = async (req: {
  pageSize: number;
  pageNumber: number;
  contractId: string;
  year: number;
}) => {
  const result = await authAxios.get("/api/PaymentHistories/Count", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const fetch = async (id: string | null) => {
  const result = await authAxios.get("/api/PaymentHistories/" + id, {
    headers: authHeader(),
  });

  return result.data;
};

const fetchYears = async (req: { contractId: string }) => {
  const result = await authAxios.get("/api/PaymentHistories/years", {
    params: req,
    headers: authHeader(),
  });

  return result.data;
};

const fetchYearsByCustomer = async (req: { customerId: string }) => {
  const result = await authAxios.get("/api/PaymentHistories/ByCustomer/years", {
    params: req,
    headers: authHeader(),
  });

  return result.data;
};

const remove = async (id: string) => {
  const result = await authAxios.delete("/api/PaymentHistories/" + id, {
    headers: authHeader(),
  });

  return result.data;
};

const edit = async (id: string, req: any) => {
  const result = await authAxios.put("/api/PaymentHistories/" + id, req, {
    headers: authHeader(),
  });

  return result.data;
};

const recalculate = async (id: string) => {
  const result = await authAxios.put(
    "/api/PaymentHistories/" + id + "/Recalculate",
    {},
    {
      headers: authHeader(),
    }
  );

  return result.data;
};

const initialize = async (
  contractId: string,
  date?: string,
  paymentHistoryId?: string
) => {
  const result = await authAxios.get("/api/PaymentHistories/Initialize", {
    params: { contractId, date, paymentHistoryId },
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const create = async (req: any) => {
  const result = await authAxios.post("/api/PaymentHistories", req, {
    headers: authHeader(),
  });

  return result.data;
};

const fetchTotals = async (req: any) => {
  const result = await authAxios.get(`/api//PaymentHistories/Totals`, {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const PaymentHistoryService = {
  fetchAll,
  fetchCount,
  fetch,
  fetchYears,
  fetchYearsByCustomer,
  remove,
  edit,
  recalculate,
  initialize,
  create,
  fetchTotals,
};

export default PaymentHistoryService;
